export const NEW_SECTION_ID_PREFIX = 'new_group_';
export const NEW_COLUMN_ID_PREFIX = 'new_column_';
export const NEW_VIEW_KEY_PREFIX = 'new_view_';
